import React from 'react';

import { cn } from '../../utils/bem';
import { usePropsHandler } from '../EventInterceptor/usePropsHandler';
import {
  BackgroundDecor,
  BackgroundDecorPropView,
} from '@dataartdev/uikit/BackgroundDecor';
import { SiteBlock } from '../SiteBlock/SiteBlock';

import Components from './templates';
import { RoutePaths } from '../../../router';
import { BodyType } from './ContentBuilder';
import { Member } from './templates/models/CTI_3.props';
import { IContent } from '../../../types/common';
import { IDictionariesForm } from '../Form/models';

interface Props<T> {
  type: number;
  items?: IContent<T>[];
  id?: string;
  background?: BackgroundDecorPropView;
  contentId?: string | null;
  aliases?: RoutePaths;
  dictionariesForm?: IDictionariesForm;
  topGap?: string;
  bottomGap?: string;
  pageId?: number | null;
  title?: string;
  text?: string;
  recaptchaKey?: string;
  onSubmitForm?: (body: BodyType) => Promise<any>;
  contentPaddingsOn?: boolean;
  hideContainer?: boolean;
  gridColumns?: number;
  member?: Member;
}

export const cnContentBuilderItem = cn('ContentBuilderItem');

export function ContentBuilderItem<T>(
  props: Props<T>
): React.ReactElement<Props<T>> | null {
  const {
    type,
    background,
    contentPaddingsOn,
    topGap = !contentPaddingsOn ? (type !== 37 ? '6xl' : '') : '',
    bottomGap = !contentPaddingsOn ? (type !== 37 ? '5xl' : '') : '',
    hideContainer,
    gridColumns = 12,
    ...otherProps
  } = usePropsHandler<Props<T>>(cnContentBuilderItem(), props);

  const TemplateTag = Components[
    type as keyof typeof Components
  ] as React.ComponentType<Props<T>>;

  if (!TemplateTag) return null;

  return (
    <SiteBlock topGap={topGap} bottomGap={bottomGap} {...otherProps}>
      {background && <BackgroundDecor view={background} />}
      <div className={(!hideContainer && 'container') || 'container-fluid'}>
        <TemplateTag {...props} />
      </div>
    </SiteBlock>
  );
}
